import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import css from './Toast.scss';
import Icon from 'SF/MaterialIcon';
import classnames from 'classnames';
import { isEmptyString } from 'utils/text';

const Toast = (props) => {

  const [isVisible, setIsVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  // Call props.timeout after timeout seconds if the user do not close the modal
  useEffect(() => {
    const timeout = setTimeout(() => {
      setFadeOut(true);
      props.onTimeout();
    }, props.timeout);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  if (!isVisible) return null;
  return (
    <div className={classnames(css['container'], {[props.className]: !isEmptyString(props.className), [css.fade]: !!fadeOut})} aria-live="polite" role="alert">
      <div className="message">{props.message}</div>
      <div
        className="close-button"
        onClick={() => setIsVisible(false)}
        aria-label="Dismiss"
        role="button"
        tabIndex="0">
        <Icon icon="close" />
      </div>
    </div>
  );
}

Toast.propTypes = {
  message: PropTypes.string.isRequired,
  timeout: PropTypes.number.isRequired,
  onTimeout: PropTypes.func,
  className: PropTypes.string
};

Toast.defaultProps = {
  timeout: 5000,
  onTimeout: () => {}
};

export default Toast;
